import { Route, Routes } from "react-router-dom";

// middlewares
import AuthenticatedOnly from "routers/middlewares/AuthenticatedOnly";

// routers
import AppRouter from "routers/AppRouter";
import GuestRouter from "routers/GuestRouter";

// screens
import { NotFoundScreen } from "screens/NotFoundScreen";

function App() {
  return (
    <Routes>
      <Route path="/*" element={<GuestRouter />} />

      <Route
        path="/app/*"
        element={<AuthenticatedOnly component={AppRouter} />}
      />
      

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
}
export default App;
